import React from 'react';
import { Button, Message } from 'semantic-ui-react';

type ConsultInProgressWarningProps = {
  onConfirm: () => void;
  onDismiss: () => void;
  open: boolean;
};

/** Shared Zoom consult → in-progress confirmation (bulk header + task detail). */
export const ConsultInProgressWarning: React.FC<ConsultInProgressWarningProps> = ({ open, onDismiss, onConfirm }) => {
  if (!open) return null;
  return (
    <Message
      warning
      onDismiss={onDismiss}
      header="Consult task: set to In progress?"
      content={
        <div>
          <p>
            Zoom API integration uses requested/in-progress statuses to update tasks. Are you sure you want to
            make this change?
          </p>
          <Button size="small" onClick={onDismiss}>
            Go back
          </Button>{' '}
          <Button size="small" primary onClick={onConfirm}>
            Yes, update status
          </Button>
        </div>
      }
    />
  );
};
